import {
  iconCommonProps, iconDefaultProps, iconPropTypes
} from '../propTypes';

const Airplay = ({ className, color }) => (
  <svg
    className={ className }
    { ...iconCommonProps }
    viewBox='0 0 19.41 19.41'
  >
    <g
      fill={ color }
      fillRule='evenodd'
      stroke='none'
      strokeWidth='1'
    >
      <g
        fill={ color }
        transform='translate(-615.000000, -972.000000)'
      >
        <g transform='translate(0.000000, 936.000000)'>
          <g transform='translate(615.000000, 36.000000)'>
            <path d='M8.94117647,8.47058824 L15.5294118,16 L2.35294118,16 L8.94117647,8.47058824 Z M15.3184677,2.16938298e-16 C16.2099865,-1.26047399e-16 16.5332727,0.0928256111 16.8591986,0.267132704 C17.1851246,0.441439796 17.4409131,0.697228371 17.6152202,1.0231543 C17.7895273,1.34908022 17.8823529,1.67236646 17.8823529,2.5638852 L17.8823529,9.67140892 C17.8823529,10.5629277 17.7895273,10.8862139 17.6152202,11.2121398 C17.4409131,11.5380657 17.1851246,11.7938543 16.8591986,11.9681614 C16.5332727,12.1424685 16.2099865,12.2352941 15.3184677,12.2352941 L14.118,12.235 L12.706,10.823 L15.4705882,10.8235294 C15.9834241,10.8235294 16.4060954,10.4374892 16.4638605,9.94015054 L16.4705882,9.82352941 L16.4705882,2.41176471 C16.4705882,1.85947996 16.022873,1.41176471 15.4705882,1.41176471 L2.41176471,1.41176471 C1.89892887,1.41176471 1.47625755,1.7978049 1.41849244,2.29514358 L1.41176471,2.41176471 L1.41176471,9.82352941 C1.41176471,10.3363653 1.7978049,10.7590366 2.29514358,10.8168017 L2.41176471,10.8235294 L5.176,10.823 L3.764,12.235 L2.5638852,12.2352941 C1.67236646,12.2352941 1.34908022,12.1424685 1.0231543,11.9681614 C0.697228371,11.7938543 0.441439796,11.5380657 0.267132704,11.2121398 C0.0928256111,10.8862139 4.01235366e-17,10.5629277 -6.90560205e-17,9.67140892 L6.90560205e-17,2.5638852 C-4.01235366e-17,1.67236646 0.0928256111,1.34908022 0.267132704,1.0231543 C0.441439796,0.697228371 0.697228371,0.441439796 1.0231543,0.267132704 C1.34908022,0.0928256111 1.67236646,6.01853049e-17 2.5638852,-1.03584031e-16 L15.3184677,2.16938298e-16 Z' />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

Airplay.propTypes = { ...iconPropTypes };

Airplay.defaultProps = { ...iconDefaultProps };

export default Airplay;